module.exports = "/_next/static/images/shieldalt-ded86784fb89602d60a821497758b9f3.svg";